import cognito from './cognito';
import crm from './crm';
import bangeo from './bangeo';
import shopify from './shopify';

export default {
	cognito,
	crm,
	bangeo,
	shopify
}
